import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';


import { SummaryOwnFinancingModel } from '../../models/summary-own-financing.model';
import { OwnFinancingService } from '../../services/own-financing.service';

import { OwnFinancingActionTypes, LoadOwnFinancing,LoadOwnFinancingFailure,LoadOwnFinancingSuccess,LoadOwnFinancings,LoadOwnFinancingsFailure,LoadOwnFinancingsSuccess,UpdateOwnFinancing,UpdateOwnFinancingFailure,UpdateOwnFinancingSuccess,DeleteOwnFinancing,DeleteOwnFinancingFailure,DeleteOwnFinancingSuccess } from '../actions/own-financing.actions';

@Injectable()
export class OwnFinancingEffects {
  constructor(
    private actions$: Actions,
    private service: OwnFinancingService
  ) { }

  /** 🔹 Get All */

  
  loadOwnFinancings$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(OwnFinancingActionTypes.LoadOwnFinancings),
    mergeMap((action: LoadOwnFinancings) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryOwnFinancingModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadOwnFinancingsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadOwnFinancingsSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadOwnFinancingsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadOwnFinancingById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(OwnFinancingActionTypes.LoadOwnFinancing),
        mergeMap((action: LoadOwnFinancing) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadOwnFinancingSuccess(response)),
            catchError(error => of(new LoadOwnFinancingFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateOwnFinancing$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(OwnFinancingActionTypes.UpdateOwnFinancing),
          mergeMap((action: UpdateOwnFinancing) =>
            this.service.update(action.payload.ownFinancing).pipe(
              switchMap(updated => [
                new UpdateOwnFinancingSuccess({ ownFinancing: updated }),
              ]),
              catchError(error => of(new UpdateOwnFinancingFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteOwnFinancing$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(OwnFinancingActionTypes.DeleteOwnFinancing),
          mergeMap((action: DeleteOwnFinancing) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteOwnFinancingSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteOwnFinancingFailure({ error })))
            )
          )
        ));



}
